<div class="select-one">
  <mat-form-field appearance="outline" class="campo-select" [style.width.px]="fieldWidth">
    <mat-label class="mat-label-text">{{ label }}</mat-label>
    <div matPrefix class="input-icone">
      @if (selectedValue !== null && selectedValue !== undefined) {
        <i
          class="fa fa-check-circle fa-lg check"
          aria-hidden="true"
        ></i>
      }
    </div>
    <mat-select
      #singleSelect
      disableOptionCentering
      (valueChange)="onChangeValue($event)"
      [(value)]="selectedValue"
      [panelWidth]="panelWidth"
      panelClass="select-component">
      @if (buscaComPesquisa) {
        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel="Nenhum resultado encontrado."
            [formControl]="searchControl || filtroBusca"
            placeholderLabel="Buscar">
          </ngx-mat-select-search>
        </mat-option>
      }
      @if (descricaoPadraoApresentar) {
        <mat-option
          [value]="valorPadrao"
          [ngClass]="{ 'option-destaque': highlightDefaultOption }"
          >
          {{ getTransformedText(descricaoPadraoApresentar) }}
        </mat-option>
      }
      @for (o of objetosRetornados | async; track o; let isFirst = $first) {
        <mat-option
          [value]="o.id"
        [ngClass]="{
          'option-destaque': isFirst && highlightFirstOption
        }"
          >
          {{ getTransformedText(o.label) }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
